export default __webpack_public_path__ + "static/media/head.ec136eac.png";